"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = void 0;
const axios_class_1 = require("./axios.class");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
class Auth {
    constructor() {
        this.refreshToken = null;
        this.accessToken = null;
    }
    sendSMSloginOrCreation({ phoneNumber, isAndroid, language, recaptchaToken, whatsapp }) {
        return axios_class_1.axios.post(`/v1/auth/sms`, { phone: phoneNumber, isAndroid, language, recaptchaToken, whatsapp });
    }
    async login({ phone, email, code, token }) {
        if ((!code && !token))
            throw new Error('Missing code or token');
        if ((!phone && !email && !token))
            throw new Error('Missing email or phone.');
        const { data } = await axios_class_1.axios.post('v2/auth/login', {
            email,
            phone,
            code,
            token,
        });
        return this.processToken(data);
    }
    async sendCode({ email, phone, language, isAndroid, recaptchaToken }) {
        if ((!phone && !email))
            throw new Error('Missing email or phone.');
        const { data } = await axios_class_1.axios.post('auth/sendCode', {
            email,
            phone,
            language,
            isAndroid,
            recaptchaToken
        });
        return data;
    }
    async checkPin(code) {
        try {
            await axios_class_1.axios.post('authorizations/checkPin', {
                pin: code
            });
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    async refresh() {
        if (!this.refreshToken)
            throw new Error('RefreshToken not found.');
        const { data } = await axios_class_1.axios.post('auth/refresh', {
            refreshToken: this.refreshToken
        });
        return this.processToken(data);
    }
    setRefreshToken(refreshToken) {
        this.refreshToken = refreshToken;
    }
    setAccessToken(accessToken) {
        this.accessToken = accessToken;
        axios_class_1.axios.setAuthorization(accessToken);
    }
    async setClientId(clientId) {
        const { data } = await axios_class_1.axios.post('/v1/auth/selectClient', {
            clientId,
            refreshToken: this.refreshToken
        });
        return data;
    }
    hasValidRefreshToken() {
        if (!this.refreshToken)
            return false;
        const decoded = (0, jwt_decode_1.default)(this.refreshToken);
        if (!decoded.exp)
            return false;
        return decoded.exp * 1000 >= Date.now();
    }
    hasValidAccessToken() {
        if (!this.accessToken)
            return false;
        const decoded = (0, jwt_decode_1.default)(this.accessToken);
        if (!decoded.exp)
            return false;
        return decoded.exp * 1000 >= Date.now();
    }
    processToken(data) {
        axios_class_1.axios.setAuthorization(data.accessToken);
        this.setRefreshToken(data.refreshToken);
        this.setAccessToken(data.accessToken);
        return data;
    }
    async getMarketplaceByPersonalizedLink(personalizedLink) {
        const { data } = await axios_class_1.axios.get(`/v1/marketplace/personalizedLink/${personalizedLink}`);
        return data;
    }
    async getMarketplaceById(marketplaceId) {
        const { data } = await axios_class_1.axios.get(`/v1/marketplace/${marketplaceId}`);
        return data;
    }
    async logout() {
        return await axios_class_1.axios.delete(`auth/logout`);
    }
}
exports.auth = new Auth();
